export default __webpack_public_path__ + "static/henna4-fa4f19f7f5646d178b510a4b0ca35605.png";